/* eslint-disable @typescript-eslint/no-explicit-any */

import { ApiHeaders } from "./headers.types";

import { QueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { CustomApiException } from "@/exceptions/custom-api-error";
import useRequestHeaders from "./use-generate-headers";

export type QueryFunctionType<R = void, T = any> = (
  data: R | undefined, // data might be undefined for GET requests
  headers: ApiHeaders,
  encryption: boolean
) => Promise<AxiosResponse<T>>;

export default function useApiQuery<R = void, T = any>(
  queryKey: QueryKey,
  queryFunction: QueryFunctionType<R, T>,
  serviceType: string,
  data?: R, // optional
  options?: Partial<UseQueryOptions<AxiosResponse<T>, CustomApiException>>
) {
  const { generateHeaders } = useRequestHeaders(serviceType);

  const query = useQuery<AxiosResponse<T>, CustomApiException>({
    queryKey,
    queryFn: async () => {
      return queryFunction(data, generateHeaders(), false);
    },
    retry: false,
    ...options,
  });

  return query;
}
